import OrganisationHospitalDTO from '@src/adapters/dto/hospital/OrganisationHospitalDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

type Result = OrganisationHospitalDTO;

const options: ApiOptions = {
  method: 'get',
  urlPath: '/hospital',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useGetHospitalLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useGetHospitalLazy;
